export default __webpack_public_path__ + "static/media/feb2024-3.04bba692.jpg";